import { InferType, object, string } from 'yup';

const errorSchema = object({
  messageId: string().required(),
  message: string().required(),
});

type TLootBoyError = InferType<typeof errorSchema>;

export function parseLootBoyError(
  error: unknown,
  fallbackMessage?: string,
): TLootBoyError {
  if (errorSchema.isType(error)) {
    return error;
  }
  return { message: fallbackMessage ?? '', messageId: 'common_error' };
}
